/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Androidbetabanner_Dismiss2Inputs */

const id_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup spanduk`)
};

const ms_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup sepanduk`)
};

const da_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis banner`)
};

const de_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner schließen`)
};

const en_us2_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss banner`)
};

const es_es2_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar banner`)
};

const es_mx2_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar banner`)
};

const fil_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-dismiss ang banner`)
};

const fr_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la bannière`)
};

const it_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi banner`)
};

const hu_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner elutasítása`)
};

const nl_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner sluiten`)
};

const no_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukk banner`)
};

const pl_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzuć baner`)
};

const pt_br2_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss banner`)
};

const pt_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispensar banner`)
};

const ro_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respinge bannerul`)
};

const fi_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylkää banneri`)
};

const sv_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avfärda banner`)
};

const vi_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ qua banner`)
};

const tr_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner'ı kapat`)
};

const cs_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít banner`)
};

const bg_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затваряне на банера`)
};

const ru_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть баннер`)
};

const uk_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приховати банер`)
};

const ar_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إخفاء اللافتة`)
};

const hi_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैनर हटाएँ`)
};

const th_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดแบนเนอร์`)
};

const ja_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バナーを閉じる`)
};

const zh_cn2_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss banner`)
};

const zh_hant1_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss banner`)
};

const ko_components_androidbetabanner_dismiss2 = /** @type {(inputs: Components_Androidbetabanner_Dismiss2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss banner`)
};

/**
* | output |
* | --- |
* | "Dismiss banner" |
*
* @param {Components_Androidbetabanner_Dismiss2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_androidbetabanner_dismiss2 = /** @type {((inputs?: Components_Androidbetabanner_Dismiss2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Androidbetabanner_Dismiss2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_androidbetabanner_dismiss2(inputs)
	if (locale === "ms") return ms_components_androidbetabanner_dismiss2(inputs)
	if (locale === "da") return da_components_androidbetabanner_dismiss2(inputs)
	if (locale === "de") return de_components_androidbetabanner_dismiss2(inputs)
	if (locale === "en-US") return en_us2_components_androidbetabanner_dismiss2(inputs)
	if (locale === "es-ES") return es_es2_components_androidbetabanner_dismiss2(inputs)
	if (locale === "es-MX") return es_mx2_components_androidbetabanner_dismiss2(inputs)
	if (locale === "fil") return fil_components_androidbetabanner_dismiss2(inputs)
	if (locale === "fr") return fr_components_androidbetabanner_dismiss2(inputs)
	if (locale === "it") return it_components_androidbetabanner_dismiss2(inputs)
	if (locale === "hu") return hu_components_androidbetabanner_dismiss2(inputs)
	if (locale === "nl") return nl_components_androidbetabanner_dismiss2(inputs)
	if (locale === "no") return no_components_androidbetabanner_dismiss2(inputs)
	if (locale === "pl") return pl_components_androidbetabanner_dismiss2(inputs)
	if (locale === "pt-BR") return pt_br2_components_androidbetabanner_dismiss2(inputs)
	if (locale === "pt") return pt_components_androidbetabanner_dismiss2(inputs)
	if (locale === "ro") return ro_components_androidbetabanner_dismiss2(inputs)
	if (locale === "fi") return fi_components_androidbetabanner_dismiss2(inputs)
	if (locale === "sv") return sv_components_androidbetabanner_dismiss2(inputs)
	if (locale === "vi") return vi_components_androidbetabanner_dismiss2(inputs)
	if (locale === "tr") return tr_components_androidbetabanner_dismiss2(inputs)
	if (locale === "cs") return cs_components_androidbetabanner_dismiss2(inputs)
	if (locale === "bg") return bg_components_androidbetabanner_dismiss2(inputs)
	if (locale === "ru") return ru_components_androidbetabanner_dismiss2(inputs)
	if (locale === "uk") return uk_components_androidbetabanner_dismiss2(inputs)
	if (locale === "ar") return ar_components_androidbetabanner_dismiss2(inputs)
	if (locale === "hi") return hi_components_androidbetabanner_dismiss2(inputs)
	if (locale === "th") return th_components_androidbetabanner_dismiss2(inputs)
	if (locale === "ja") return ja_components_androidbetabanner_dismiss2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_androidbetabanner_dismiss2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_androidbetabanner_dismiss2(inputs)
	return ko_components_androidbetabanner_dismiss2(inputs)
});
export { components_androidbetabanner_dismiss2 as "components.androidBetaBanner.dismiss" }